import { getter } from "@progress/kendo-data-query";

export const DATA_ITEM_KEY = "id";
export const SELECTED_FIELD = "isSelected";
export const EXPANDED_FIELD = "isExpanded";
export const idGetter = getter(DATA_ITEM_KEY);
export const logOutInProgress = "logOutInProgress";
export const signInProgress = "signInProgress";
